import { render } from "./SecurityQuestionSelect.vue?vue&type=template&id=38aab6f8&ts=true"
import script from "./SecurityQuestionSelect.vue?vue&type=script&lang=ts"
export * from "./SecurityQuestionSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__